import { Model } from '@/clients/http'

import { IpBlockHttpParams, IpBlockResponses } from '@/types'

export class IpBlockModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_IP_BLOCK_LIST',
    GET_BY_ID: 'GET_IP_BLOCK_BY_ID',
    CREATE: 'CREATE_IP_BLOCK',
    UPDATE: 'UPDATE_IP_BLOCK',
    DELETE: 'DELETE_IP_BLOCK',
  }

  public static readonly endpoints = {
    getList: (props?: IpBlockHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/ip-block',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: IpBlockHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/ip-block/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: IpBlockHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/ip-block',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: IpBlockHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/ip-block/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: IpBlockHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/ip-block/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: IpBlockHttpParams.GetList) => {
    return this.createHttpRequest<IpBlockResponses.GetList, IpBlockResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: IpBlockHttpParams.Create) => {
    return this.createHttpRequest<IpBlockResponses.Create, IpBlockResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: IpBlockHttpParams.Update) => {
    return this.createHttpRequest<IpBlockResponses.Update, IpBlockResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly delete = async (props: IpBlockHttpParams.Delete) => {
    return this.createHttpRequest<IpBlockResponses.Delete, IpBlockResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
